import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { PolicyDialog } from "@/components/legal";
import { useLang } from "@/i18n";

const KEY = "pst_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const c = t.cookie;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[60] bg-ink text-white border-t-2 border-ferrari"
        >
          <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-5 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
            <div className="flex items-start gap-3 flex-1">
              <Cookie size={24} className="text-ferrari shrink-0 mt-0.5" />
              <p className="text-sm text-white/80 leading-relaxed">
                {c.pre}
                <PolicyDialog type="cookie">
                  <button data-testid="banner-cookie-policy-link" className="underline text-white hover:text-ferrari transition-colors">{c.cookieLink}</button>
                </PolicyDialog>
                {c.mid}
                <PolicyDialog type="privacy">
                  <button data-testid="banner-privacy-link" className="underline text-white hover:text-ferrari transition-colors">{c.privacyLink}</button>
                </PolicyDialog>.
              </p>
            </div>
            <div className="flex gap-3 shrink-0">
              <button
                data-testid="cookie-reject-btn"
                onClick={() => decide("rejected")}
                className="px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] border border-white/40 hover:border-white hover:bg-white/10 transition-colors"
              >
                {c.reject}
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={() => decide("accepted")}
                className="px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] bg-ferrari text-white hover:bg-white hover:text-ink transition-colors"
              >
                {c.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
